import ChangePasswordModal from './components/ChangePasswordModal';

export const modals = {
  CHANGE_PASSWORD: ChangePasswordModal
};

export default modals;
